
import { SeoData } from "./interfaces/seo.types";
import { Commons } from './Commons';
import { environment } from "../../environments/environment";

export class CustomMetaData {
  static readonly HOME: SeoData = {
    title: `${environment.dfConfigCompanyName} | ${environment.dfConfigSlogan}`,
    description: `${environment.dfConfigAbout}`,
    canonicalPath: '/',
    meta: [
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` }
    ],
    index: true
  };

  static readonly ABOUT: SeoData = {
    title: `Sobre Nosotros | ${environment.dfConfigCompanyName}`,
    description: `Conoce la historia, misión y valores de ${environment.dfConfigCompanyName}.`,
    canonicalPath: `/${Commons.PATH_ABOUT}`,
    index: environment.home.about_us === 'page'
  };

  static readonly TEAM: SeoData = {
    title: `Nuestro Equipo de Profesionales | ${environment.dfConfigCompanyName}`,
    description: `Conoce al equipo de ${environment.dfConfigCompanyName}`,
    canonicalPath: `/${Commons.PATH_TEAM}`,
    index: environment.home.team === 'page'
  };

  static readonly CONTACT: SeoData = {
    title: `Contáctanos | ${environment.dfConfigCompanyName}`,
    description: `Escríbenos para asesoría tecnológica, automatización y desarrollo a medida.`,
    canonicalPath: `/${Commons.PATH_CONTACT}`,
    index: environment.home.contact === 'page'
  };

  static readonly SERVICES: SeoData = {
    title: `Servicios | ${environment.dfConfigCompanyName}`,
    description: `Desarrollo web y móvil, automatización de procesos, integración cloud y soporte continuo.`,
    canonicalPath: `/${Commons.PATH_SERVICES}`,
    index: environment.home.services === 'page'
  };

  static readonly LOCATION: SeoData = {
    title: `Ubicación y Cómo Llegar | ${environment.dfConfigCompanyName}`,
    description: `Encuentra ${environment.dfConfigCompanyName}`,
    canonicalPath: `/${Commons.PATH_LOCATION}`,
    index: environment.home.map === 'page'
  };

  static readonly PUBLICATIONS: SeoData = {
    title: `Noticias y Publicaciones | ${environment.dfConfigCompanyName}`,
    description: `Lee las últimas noticias y publicaciones de ${environment.dfConfigCompanyName}`,
    canonicalPath: `/${Commons.PATH_PUBLICATIONS}`,
    index: environment.home.publications === 'page'
  };

  static readonly GALLERY: SeoData = {
    title: `Galería de Imágenes | ${environment.dfConfigCompanyName}`,
    description: `Explora la galería de fotos de ${environment.dfConfigCompanyName}`,
    canonicalPath: `/${Commons.PATH_GALLERY}`,
    index: environment.home.gallery === 'page'
  };

  /* BEGIN | CUSTOM SERVICE SEO — actualizar title, description y canonicalPath por cliente */
  static readonly SERVICE_1: SeoData = {
    title: `Servicio 1 | ${environment.dfConfigCompanyName}`,
    description: `Conoce en detalle el Servicio 1 de ${environment.dfConfigCompanyName}: beneficios, proceso de trabajo y cómo puede ayudarte.`,
    canonicalPath: `/${Commons.PATH_SERVICES}/service-1`,
    meta: [
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` }
    ],
    index: environment.home.services === 'page'
  };

  static readonly SERVICE_2: SeoData = {
    title: `Servicio 2 | ${environment.dfConfigCompanyName}`,
    description: `Conoce en detalle el Servicio 2 de ${environment.dfConfigCompanyName}: beneficios, proceso de trabajo y cómo puede ayudarte.`,
    canonicalPath: `/${Commons.PATH_SERVICES}/service-2`,
    meta: [
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` }
    ],
    index: environment.home.services === 'page'
  };

  static readonly SERVICE_3: SeoData = {
    title: `Servicio 3 | ${environment.dfConfigCompanyName}`,
    description: `Conoce en detalle el Servicio 3 de ${environment.dfConfigCompanyName}: beneficios, proceso de trabajo y cómo puede ayudarte.`,
    canonicalPath: `/${Commons.PATH_SERVICES}/service-3`,
    meta: [
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` }
    ],
    index: environment.home.services === 'page'
  };
  /* END | CUSTOM SERVICE SEO */

}
